<div>
    <div class="flex">
        <div>
            <div class="flex items-center gap-2">

                <app-solid-star-icon
                    (click)="updateRating(1)"
                    class="w-8 h-8 cursor-pointer transition"
                    [ngClass]="rating?.rating === PerformanceRatingsEnum.Love
                    ? 'text-emerald-600 scale-110'
                    : 'text-slate-300 hover:text-emerald-500'">
                </app-solid-star-icon>

                <app-solid-star-icon
                    (click)="updateRating(2)"
                    class="w-8 h-8 cursor-pointer transition"
                    [ngClass]="rating?.rating === PerformanceRatingsEnum.Like
                    ? 'text-amber-600 scale-110'
                    : 'text-slate-300 hover:text-amber-500'">
                </app-solid-star-icon>

                <app-solid-star-icon
                    (click)="updateRating(3)"
                    class="w-8 h-8 cursor-pointer transition"
                    [ngClass]="rating?.rating === PerformanceRatingsEnum.Loathe
                    ? 'text-rose-600 scale-110'
                    : 'text-slate-300 hover:text-rose-500'">
                </app-solid-star-icon>

            </div>
        </div>
    </div>
    <div class="w-full">
        <textarea class="h-22 w-full"></textarea>
    </div>
</div>